import React from "react";
import { createRoot } from "react-dom/client";
import { useAtom } from "tiny-atom/react/hooks";
import { moonwave as m } from ".";
import AuthService from "../auth";

export { Provider } from "tiny-atom/react";

export function Routes({ router, components }) {
  const route = useAtom(state => state.route);

  if (route.pathname !== "/consult" && AuthService.role() === "PARENT") {
    AuthService.logout();
  }

  const componentList = router.data(route.pattern);
  return componentList.reduceRight((children, componentName) => {
    let props = {};
    if (Array.isArray(componentName)) {
      props = componentName[1];
      componentName = componentName[0];
    }
    const Component = components[componentName];
    return <Component {...props}>{children}</Component>;
  }, null);
}

export function moonwave(options) {
  return m(options).install(render, unrender);
}

/**
 * Get the current route,
 * get the associated components,
 * render them in a nested fashion
 * and finally render the app into DOM
 */
const render = (App, app) => {
  const { atom, router } = app;
  const container = document.getElementById("root");
  const root = createRoot(container);
  root.render(<App app={app} atom={atom} router={router} />); /* eslint-disable-line no-undef */
};

/**
 * Overwrite the target DOM element with nothing
 */
const unrender = () => {
  const container = document.getElementById("root");
  const root = createRoot(container);
  root.render(null);
};
